import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoContato } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoContatoService extends BaseResourceService<FavorecidoContato> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-contatos`, injector);
  }

}
